<style>
	.slide-fade-enter-active {
	  transition: all .2s ease;
	}
	.slide-fade-leave-active {
	  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter, .slide-fade-leave-active {
	  padding-left: 10px;
	  opacity: 0;
	}
	.default{
		position:relative;
		left: 0%;
		height: 100%;
		overflow-x:hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
		background-color: #eee;
	}
	.default-option{
		position: relative;
		left: 0%;
		height: 100%;
	}
	.bill-count-status-title{
		background: none !important;
		border-bottom: none !important;
		height: 30px !important;
	}
	.bill-count-status-style{
		margin-left: 5% !important;
		width: 95% !important;
		color: #848484;
	}
</style>
<template>
	<span>
		<transition name="slide">
			<div v-if="show" class="bill-filter-mask">
				<div class="bill-filter-wrapper">
					<a class="bill-filter-cancel" @click="cancle">取消</a>
					<!-- <navbar title="餐企订单筛选"></navbar> -->
					<nav class="edi-nav">单据统计筛选</nav>
					<div class="summary-filter-shell">
						<ul class="summary-filter-ul">
							<li class="bill-count-status-title">单据状态</li>
							<li class="bill-count-status-style" @click="selectBillStatus(billStateId, billStateFont)">餐企订单：&nbsp;
								<span>{{billStateFont}}</span>
							</li>
							<li class="bill-count-status-style" @click="selectBillStatusS(billStateIdT, billStateFontT)">餐企退单：&nbsp;
								<span>{{billStateFontT}}</span>
							</li>
							<!-- <li @click="selectDateType">排序方式：&nbsp; <span>{{dateTypeFont}}</span></li> -->
							<li @click="selectCompany">餐企名称：&nbsp; <span style="color: #848484">{{restaurantName}}</span></li>
						</ul>
						<a class="summary-filter-btn" @click="printData">确定</a>
					</div>
				</div>
			</div>
		</transition>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<bill-status-select ref="billStatuselectShow" v-on:confirm="getBillStatus" :billStatusFlag="billState" :billStateFont="billStateFont" title="单据统计-选择餐企订单状态"></bill-status-select>
		<!-- <date-type-select ref="dateTypeShow" v-on:selectDateType="getDateType" :dateTypeFlag="dateTypeFlag" title="单据统计-选择排序方式"></date-type-select> -->
		<company-select ref="companySelectShow" v-on:selectCompany="companyStatus" :selectedId="restaurantId" :selectedName="restaurantName"></company-select>
		<bill-status-selects ref="billStatuselectShowS" v-on:confirm="getBillStatusT" :billStatusFlag="billState" :billStateFont="billStateFont" title="单据统计-选择餐企退单状态"></bill-status-selects>
	</span>
</template>
<script>
import CompanyFilter from '../components/FoodCompanyFilter'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import BillStatusSelect from '../components/BillStatusSelectM'
import BillStatusSelectS from '../components/BillStatusSelectS'
import DateTypeSelect from '../components/DateTypeSelect'
import CompanySelect from '../components/CompanySelect'
// selectArr为从上一个页面传过来单据状态的标识符，并把它转化为数组
// belong 为绑定单据状态数据的函数
export default {
	components: {
		'company-filter': CompanyFilter,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'date-type-select': DateTypeSelect,
		'bill-status-select': BillStatusSelect,
		'bill-status-selects': BillStatusSelectS,
		'company-select': CompanySelect
	},
	props: {
		filterBillState: String,
		filterRestaurantId: String,
		filterRestaurantName: String
	},
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			show: false,
			appear: false,
			isHide: true,
			selectArr: this.filterBillState.split(','),
			restaurantId: '',
			restaurantName: '',
			sec: 1500,
			totalStatus: false,
			billState: '12,21',
			billStateFont: '',
			billStateId: '',
			billStateFontT: '',
			billStateIdT: '',
			dateTypeFlag: '',
			dateTypeFont: '',
			sort: ''
		}
	},
	created () {
		// this.billState = this.filterBillState.split(',')
		// window.console.log(this.billState)
		// window.console.log(this.filterRestaurantName)
	},
	methods: {
		getBillStatus (msg) {
			window.console.log(msg)
			this.billStateId = msg[0].join(',')
			this.billStateFont = msg[1].join(',')
			// window.console.log(this.billStateFont)
		},
		getBillStatusT (msg) {
			// window.console.log(msg)
			this.billStateIdT = ''
			this.billStateFontT = ''
			this.billStateIdT = msg[0].join(',')
			this.billStateFontT = msg[1].join(',')
		},
		getDateType (msg) {
			this.dateTypeFlag = msg
			this.sort = this.dateTypeFlag
			// window.console.log(msg)
			switch (msg) {
			case '0':
				this.dateTypeFont = '订货日期'
				break
			case '1':
				this.dateTypeFont = '到货日期'
				break
			}
		},
		confirm () {
			/* if (this.end_date < this.start_date) {
				this.autoTips('结束日期不能小于开始日期')
				return false
			}
			if (this.billState.length === 0) {
				this.autoTips('请至少选择一种单据状态')
				return false
			}
			this.show = false
			window.console.log(str)
			this.$emit('confirm', str) */
			// this.show = false
			// var str = this.sort + '|' + this.billState + '|' + this.restaurantName + '|' + this.restaurantId
		},
		companyStatus (msg) {
			var str = msg.split('|')
			this.restaurantId = str[0]
			this.restaurantName = str[1]
			// window.console.log(this.restaurantName + ',' + this.restaurantId)
		},
		selectBillStatus (flag, font) {
			this.$refs.billStatuselectShow.open(flag, font)
		},
		selectBillStatusT (flag, font) {
			this.$refs.billStatuselectShowT.open(flag, font)
		},
		selectBillStatusS (flag, font) {
			this.$refs.billStatuselectShowS.open(flag, font)
		},
		selectDateType () {
			this.$refs.dateTypeShow.open()
		},
		selectCompany () {
			this.$refs.companySelectShow.open()
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		move (obj) {
			window.console.log(obj)
			this.show = !this.show
			// this.billState = this.filterBillState.split(',')
			// window.console.log(this.totalStatus)
			// this.$emit('open')
			this.showInit(obj)
		},
		showInit (obj) {
			this.billStateFont = obj.order_state_font
			this.billStateId = obj.order_state
			this.billStateFontT = obj.back_state_font
			this.billStateIdT = obj.back_state
		},
		belong (val) {
			if (this.billState.indexOf(val) !== -1) {
				return true
			} else {
				return false
			}
		},
		selectState (val) {
			var index = this.billState.indexOf(val)
			if (index === -1) {
				this.billState.push(val)
				// window.console.log(this.billState)
				return false
			} else {
				this.billState.splice(index, 1)
				// window.console.log(this.billState)
				return false
			}
		},
		backValue (msg) {
			// 获取选中的餐企ID
			var str = msg
			str = str.split('|')
			// window.console.log(str)
			this.restaurantId = str[0]
			this.restaurantName = str[1]
		},
		printData () {
			// if (this.billState.length === 0) {
			// 	this.autoTips('请至少选择一种单据状态')
			// 	return false
			// }
			// window.console.log(this.billState.length)
			this.show = !this.show
			var obj = {
				order_state_font: this.billStateFont,
				order_state: this.billStateId,
				back_state_font: this.billStateFontT,
				back_state: this.billStateIdT,
				restaurantId: this.restaurantId,
				restaurantName: this.restaurantName
			}
			// var str = this.restaurantId + '|' + this.billState.join(',') + '|' + this.restaurantName
			// window.console.log(str)
			this.$emit('printData', obj)
		},
		cancle () {
			this.show = !this.show
		}
	}
}
</script>



// WEBPACK FOOTER //
// BillCountFilter.vue?c2dff99e